import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useIntl } from "react-intl";
import { messages } from "../../../messages";
import { clsx } from "clsx";
const SlideinOverlay = ({ open, onClose, classes, children }) => {
    const intl = useIntl();
    return (_jsxs(_Fragment, { children: [_jsx(Box, { className: clsx(classes.backdrop, !open && classes.backdropHidden), onClick: open ? onClose : undefined }), _jsxs(Box, { className: clsx(classes.slideinOverlay, open && classes.slideinOverlayOpen), children: [_jsx(Button, { startIcon: _jsx(CloseIcon, {}), className: clsx(classes.closeButton, classes.closeButtonDesktop), onClick: onClose, children: intl.formatMessage(messages.slideinClose) }), children] })] }));
};
export default SlideinOverlay;
//# sourceMappingURL=SlideinOverlay.js.map